import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { LOCATION_API } from "./apiRoutes";

interface UseGetStatesListByCountryProps {
  countryId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}
const getStatesListByCountry = async (countryId: string) => {
  return await axiosAuth.get(`${LOCATION_API}/countries/${countryId}/states`);
};

const useGetStatesListByCountry = ({
  countryId,
  queryParams,
}: UseGetStatesListByCountryProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["state-list", countryId],
    queryFn: () => getStatesListByCountry(countryId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetStatesListByCountry;
